SourceHireFilterComponent.$inject = ['$element', '$timeout', 'sourceHireFiltersViewService', '$filter'];

function SourceHireFilterComponent($element, $timeout, sourceHireFiltersViewService, $filter) {
    var self = this;

    self.applyFilter = function () {
        self.onFilterApplied();
        self.isDropdownShown = false;
    };

    var adjustFilterDropdownPosition = function (filterContent, adjustedFilterClientRect) {
        filterContent.style.right = adjustedFilterClientRect.right;
        filterContent.style.left = adjustedFilterClientRect.left;
    };

    var runFilterDropdownResizeListener = function () {
        $timeout(function () {
            var filterContent = $element.find('.filter-content').get(0);
            var filterLabel = $element.find('.filter-label').get(0);
            var adjustedFilterClientRect = sourceHireFiltersViewService.getAdjustedDropdownPosition(filterLabel, filterContent);
            adjustFilterDropdownPosition(filterContent, adjustedFilterClientRect);
        }, 1);
    };

    self.$onChanges = function (changesObj) {
        if (changesObj && changesObj.isVisible && changesObj.isVisible.currentValue) {
            self.isDropdownShown = true;
            runFilterDropdownResizeListener();
        }
    };

    self.toggleDropdown = () =>{
      self.isDropdownShown = !self.isDropdownShown;
    };

    self.$postLink = function () {
        self.applyBtnLabel = self.applyBtnLabel || $filter('translate')('Done');
        let ignore = false;

        runFilterDropdownResizeListener();
        $element.on('click',function () {
            ignore = true;
        });
        $(document).on("click.source-hire-filter", function (event) {
            if (
                !ignore &&
                self.isDropdownShown
            ) {
                self.isDropdownShown = false;
            }

            ignore = false;
        });
    };

    self.$onDestroy = function () {
        $(document).off('click.source-hire-filter');
    };
}

angular
    .module("harriApp")
    .component("sourceHireFilter", {
        controller: SourceHireFilterComponent,
        transclude: true,
        bindings: {
            onRemoveFilter: '&',
            onFilterApplied: '&',
            filterLabel: '<',
            filterValue: '<',
            icon: '<',
            isVisible: '<',
            isSvgIcon: '<',
            dateFilter: '<',
            hideRemoveFilterAction: '<',
            applyBtnLabel: '<',
        },
        controllerAs: '$ctrl',
        templateUrl: '../hmodules/harri-main/components/source-hire-filter/source-hire-filter.component.ng.html'
    });
